import { render, staticRenderFns } from "./petaWilayah.vue?vue&type=template&id=c150de1c&"
import script from "./petaWilayah.vue?vue&type=script&lang=js&"
export * from "./petaWilayah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QDialog,QSelect,QItem,QItemSection,QItemLabel,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QDialog,QSelect,QItem,QItemSection,QItemLabel,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
